<script>
import { doc, panel_state } from "./util/stores.js"

let p_state, work_page

panel_state.subscribe(value => {
    p_state = value;
});

doc.subscribe((value) =>{
    work_page = value['current_page']
})

</script>

<div class="panel" style="{p_state == 'expanded' ? '' : 'width: 0px;'}">
    <div class="legend">
        <div class="text">{work_page}</div>
        <!-- <div class="line"></div> -->
    </div>
    <div class="cards">
        <div class="cards_flex">
            {#each Array(10) as _,i}
                <div class="module_prev"></div>
            {/each}
        </div>
    </div>
</div>

<style lang="scss">
    @use "styles/global.scss";

    .panel{
        width: $logo_width;
        height: 100%;

        overflow: hidden;
        position: relative;
        z-index: 5;

        background: #FFFFFF;
        box-shadow: 4px 0px 12px rgba(0, 0, 0, 0.1);

        transition: $left_panel_trans_speed ease;
    }

    .legend{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;

        width: 100%;
        height: 32px;


        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;

        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);

        .text{
            /*
            margin-top: auto;
            justify-self: center;
            */
        }

        .line{
            width: 80%;
            height: 2px;

            background-color: $grey5;
            /*
            margin-top: auto;
            justify-self: flex-end;
            */
        }
    }

    .cards{
        margin-top: 16px;
        display: block;
        width: 100%;
        height: 100%;
        overflow-y: scroll;

        @include custom_scrollbar;

        .cards_flex{
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }

    .module_prev{
        @include module_preview;
        
        margin-bottom: 54px;
        /*
        margin-left: ($logo_width - $module_prev_size)/2;
        */
    }
</style>